/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer6_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_viewer" | "ReplyListContainerLast_viewer">;
    readonly " $refType": "ReplyListContainer6_viewer";
};
export type ReplyListContainer6_viewer$data = ReplyListContainer6_viewer;
export type ReplyListContainer6_viewer$key = {
    readonly " $data"?: ReplyListContainer6_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer6_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer6_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainerLast_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '6ac063feedea928f757749875e34e973';
export default node;
